import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import { Spinner } from "./componentes/Comunes/spinner/spinner";
import { ToastContainer } from "react-toastify";
import SBAdmin2 from "./SBAdmin2";
import "react-toastify/dist/ReactToastify.css";

//JQuery
import "jquery/dist/jquery.min.js";

//Boostrap Libs
import "bootstrap/dist/js/bootstrap.bundle.min";

//SBAdmin2 Style
import "./assets/css/sb-admin-2.min.css";
import "./assets/css/sb-admin-2-custom.css";

//Datatables
import "datatables.net";
import "datatables.net/js/jquery.dataTables";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4/js/buttons.bootstrap4";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
import "datatables.net-select-bs4/js/select.bootstrap4";
import "datatables.net-select-bs4/css/select.bootstrap4.css";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-plugins/sorting/datetime-moment.js";

//Redux
import { Provider } from "react-redux";
import { Store } from "./redux/store";

ReactDOM.render(
  <Provider store={Store}>
    <App />
    <Spinner />
    <SBAdmin2 />
    <ToastContainer autoClose={20000} />
  </Provider>,
  document.getElementById("root")
);
